import I18n from 'i18n-js';
import React from 'react';
import CmsListingsCollection from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import { dealsAndStealsPromoURLPath } from './promo_url_path_for_user';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import { DEALS_AND_STEALS_CURATED_SET_ID } from '@reverbdotcom/commons/src/constants';
import { reverb_search_ListingsSearchRequest_PriceValue } from '@reverbdotcom/commons/src/rql';
import { experimentInt } from '@reverbdotcom/commons/src/user_context_helpers';

interface IProps {
  title?: string;
}

export default function HomepageDealsAndStealsListingsCollection(props: IProps) {
  const user = useUser();
  const dealsAndStealsPath = dealsAndStealsPromoURLPath(user);

  const experiment = experiments.DEALS_AND_STEALS_HOME;
  const expGroup = experimentInt(user, experiment);

  if (!user?.loggedOut && expGroup > 0) {
    return <></>;
  }

  return (
    <CmsListingsCollection
      data-deals-and-steals-listings
      curatedSetId={DEALS_AND_STEALS_CURATED_SET_ID}
      componentName="HomepageDealsAndSteals"
      ctaTargetHref={dealsAndStealsPath}
      priceValueV2={reverb_search_ListingsSearchRequest_PriceValue.GOOD}
      title={props.title || I18n.t('discovery.categoryNavBar.explore.deals')}
      maxCount={12}
      largeTiles
      ssr={false}
    />
  );
}
